import cn from 'classnames'

import { getFormattedFinance } from '../../../../../../../../helpers/getFormattedFinance'
import { getQBRFormattedPt } from '../../../../../../helpers/getQBRFormattedPt'
import styles from '../SobAchievement.module.scss'

interface IGetSobAchievementShortedCellParameters {
  actuals: number
  plans: number
  yoyActuals: number
}

export const getSobAchievementShortedCell = ({
  actuals,
  plans,
  yoyActuals,
}: IGetSobAchievementShortedCellParameters) => {
  return (
    <div className={styles.financialValue}>
      <p className={cn(styles.paragraph, styles.actuals)}>
        {getFormattedFinance(actuals, {
          maximumFractionDigits: 1,
          minimumFractionDigits: 1,
        })}
      </p>
      <p className={cn(styles.paragraph, styles.plans)}>
        {getFormattedFinance(plans, {
          maximumFractionDigits: 1,
          minimumFractionDigits: 1,
        })}
      </p>
      <p
        className={cn(styles.paragraph, {
          [styles.positive]: yoyActuals > 0,
          [styles.negative]: yoyActuals < 0,
        })}
      >
        {getQBRFormattedPt(yoyActuals)}
      </p>
    </div>
  )
}
